/**
 * Element UI 2 字体图标 → Element Plus SVG 图标 兼容层
 *
 * Element UI 2 的图标是 icon font：`<el-button icon="el-icon-plus">` / `<i class="el-icon-plus">`，
 * 样式类名 .el-icon-xxx:before 里放 content 码点。Element Plus 改为 SVG 组件（@element-plus/icons-vue），
 * 不再提供字体，所以升级后所有 el-icon-* 全部不可见（且不报错）。
 *
 * 这里把旧类名注册成同名全局组件：
 *  - `<el-button icon="el-icon-plus">`：EP Button 内部走 resolveDynamicComponent(icon)，
 *    全局注册后能解析到这个组件，图标正常渲染；
 *  - 模板里直接写 `<el-icon-plus />` 同样可用。
 * class 形式（`<i class="el-icon-plus">`）没有内容，需要在模板里换成 <el-icon><Plus /></el-icon>。
 */
import { h, defineComponent } from 'vue'
import { ElIcon } from 'element-plus'
import {
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Bell,
    Calendar,
    CaretBottom,
    Check,
    CircleCheck,
    CircleClose,
    Close,
    Delete,
    Document,
    Download,
    Edit,
    FullScreen,
    InfoFilled,
    Loading,
    Location,
    Menu,
    Minus,
    More,
    Plus,
    QuestionFilled,
    Refresh,
    RefreshLeft,
    RefreshRight,
    ScaleToOriginal,
    Search,
    Setting,
    Shop,
    Promotion,
    Star,
    Upload,
    UploadFilled,
    User,
    WarningFilled,
    ZoomIn,
    ZoomOut
} from '@element-plus/icons-vue'

/** 旧字体类名 → Element Plus 图标组件 */
export const LEGACY_ICON_MAP = {
    'el-icon-arrow-down': ArrowDown,
    'el-icon-arrow-left': ArrowLeft,
    'el-icon-arrow-right': ArrowRight,
    'el-icon-arrow-up': ArrowUp,
    'el-icon-bell': Bell,
    'el-icon-c-scale-to-original': ScaleToOriginal,
    'el-icon-caret-bottom': CaretBottom,
    'el-icon-check': Check,
    'el-icon-circle-check': CircleCheck,
    'el-icon-circle-close': CircleClose,
    'el-icon-close': Close,
    'el-icon-date': Calendar,
    'el-icon-delete': Delete,
    'el-icon-document': Document,
    'el-icon-download': Download,
    'el-icon-edit': Edit,
    'el-icon-full-screen': FullScreen,
    'el-icon-info': InfoFilled,
    'el-icon-loading': Loading,
    'el-icon-map-marker': Location,
    'el-icon-menu': Menu,
    'el-icon-minus': Minus,
    'el-icon-more': More,
    'el-icon-plus': Plus,
    'el-icon-question': QuestionFilled,
    'el-icon-refresh': Refresh,
    'el-icon-refresh-left': RefreshLeft,
    'el-icon-refresh-right': RefreshRight,
    'el-icon-search': Search,
    'el-icon-send': Promotion,
    'el-icon-setting': Setting,
    'el-icon-star': Star,
    'el-icon-store': Shop,
    'el-icon-upload': Upload,
    'el-icon-upload2': UploadFilled,
    'el-icon-user': User,
    'el-icon-warning': WarningFilled,
    'el-icon-zoom-in': ZoomIn,
    'el-icon-zoom-out': ZoomOut
}

/**
 * 把 SVG 图标包进 el-icon 以约束尺寸：
 * - 在 `<el-button icon="el-icon-plus">` 里 EP 自己会包一层 ElIcon，再嵌一层无副作用；
 * - 直接写 `<el-icon-plus />` 标签时，裸 SVG 没有尺寸约束会撑满容器，包一层才有 1em 大小。
 */
const wrap = (Icon, name) =>
    defineComponent({
        name,
        render() {
            return h(ElIcon, null, { default: () => h(Icon) })
        }
    })

export default {
    install(app) {
        Object.keys(LEGACY_ICON_MAP).forEach((name) => {
            app.component(name, wrap(LEGACY_ICON_MAP[name], name))
        })
    }
}
